
    <ng-container
      *ngIf="
        randomNumbers[0].length &&
        randomNumbers[1].length &&
        randomNumbers[2].length &&
        randomNumbers[3].length &&
        randomNumbers[4].length
      "
    >
      <div class="slots-game-content">
        <div class="slots-wrap">
          <div class="slots-bg">
            <div class="slots-row">
              <div class="slots-symbols">
                <div *ngFor="let rand of randomNumbers[0]" class="parent-symbol">
                  <div class="symbol {{coins[rand]}}"></div>
                </div>
              </div>
            </div>
            <div class="slots-row row-2">
              <div class="slots-symbols">
                <div *ngFor="let rand of randomNumbers[1]" class="parent-symbol">
                  <div class="symbol {{coins[rand]}}"></div>
                </div>
              </div>
            </div>
            <div class="slots-row row-3">
              <div class="slots-symbols">
                <div *ngFor="let rand of randomNumbers[2]" class="parent-symbol">
                  <div class="symbol {{coins[rand]}}"></div>
                </div>
              </div>
            </div>
            <div class="slots-row row-4">
              <div class="slots-symbols">
                <div *ngFor="let rand of randomNumbers[3]" class="parent-symbol">
                  <div class="symbol {{coins[rand]}}"></div>
                </div>
              </div>
            </div>
            <div class="slots-row row-5">
              <div class="slots-symbols">
                <div *ngFor="let rand of randomNumbers[4]" class="parent-symbol">
                  <div class="symbol {{coins[rand]}}"></div>
                </div>
              </div>
            </div>

            <!--
              <app-slots-win-badge *ngIf="payout.length > 0" [coins]="coins" [payout]="payout"></app-slots-win-badge>
            -->
          </div>
        </div>
      </div>
    </ng-container>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-slots.component.ts.ReplySlotsComponent.html